export interface SearchEntityMeta {
    icon: string;
    labelKey: string;
    order: number;
}

/**
 * Metadatos de presentación por tipo de `entity` devuelto por /api/search.
 * El backend indexa más subtipos de los que hoy tienen ruta propia
 * (`GET_INDEX_TERMS`: person, person_mail, group, group_militar, position,
 * position_militar, event, correspondence, gift, restaurant, material,
 * space, locations, position_contact_*) — los no listados aquí caen en
 * `SEARCH_ENTITY_META_FALLBACK` y se agrupan como "Otros".
 */
const SEARCH_ENTITY_META: Record<string, SearchEntityMeta> = {
    person: { icon: 'pi pi-user', labelKey: 'app.topbar.search.entity.person', order: 1 },
    position: { icon: 'pi pi-briefcase', labelKey: 'app.topbar.search.entity.position', order: 2 },
    position_militar: { icon: 'pi pi-briefcase', labelKey: 'app.topbar.search.entity.position', order: 2 },
    group: { icon: 'pi pi-building', labelKey: 'app.topbar.search.entity.group', order: 3 },
    group_militar: { icon: 'pi pi-building', labelKey: 'app.topbar.search.entity.group', order: 3 },
    event: { icon: 'pi pi-calendar', labelKey: 'app.topbar.search.entity.event', order: 4 },
    correspondence: { icon: 'pi pi-envelope', labelKey: 'app.topbar.search.entity.correspondence', order: 5 },
    gift: { icon: 'pi pi-gift', labelKey: 'app.topbar.search.entity.gift', order: 6 },
    restaurant: { icon: 'pi pi-utensils', labelKey: 'app.topbar.search.entity.restaurant', order: 7 },
    material: { icon: 'pi pi-box', labelKey: 'app.topbar.search.entity.material', order: 8 },
    space: { icon: 'pi pi-map-marker', labelKey: 'app.topbar.search.entity.space', order: 9 }
};

const SEARCH_ENTITY_META_FALLBACK: SearchEntityMeta = {
    icon: 'pi pi-file',
    labelKey: 'app.topbar.search.entity.other',
    order: 99
};

export function getSearchEntityMeta(entity: string): SearchEntityMeta {
    return SEARCH_ENTITY_META[entity] ?? SEARCH_ENTITY_META_FALLBACK;
}
